import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurladdress } from "../baseurl"
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import Moment from "moment";
import { Modal, Button, ModalHeader } from "react-bootstrap";
import * as Icon from 'react-bootstrap-icons';


function MyLeavelist() {


    const date = new Date();
    const futureDate = date.getDate();
    date.setDate(futureDate);
    const defaultValue = date.toLocaleDateString("en-CA");

    const id = localStorage.getItem("id");
    const username = localStorage.getItem("username");


    const accesstoken = localStorage.getItem("token");
    const [data, setData] = useState([]);
    const [staff, setstaff] = useState("");
    const [staffedit, setstaffedit] = useState("");
    const [staffid, setstaffid] = useState("");
    const [ddchrleave_id, setddchrleave_id] = useState("");
    const [showModal, setShow] = useState(false);
    const [showModals, setShows] = useState(false);
    const [staffname, setstaffname] = useState(false);
    const [leavedate, setleavedate] = useState(defaultValue);
    const [leavedateto, setleavedateto] = useState("");
    const [status, setstatus] = useState(false);
    const [reason, setreason] = useState(false);
    const navigate = useNavigate();
    const Swal = require('sweetalert2')

    useEffect(() => {
        const GetAllLeave = () => {


            axios
                .get(baseurladdress + `leavelists/` + id, {
                    headers: { Authorization: `Bearer ${accesstoken}` },
                })
                .then(res => {
                    const datas = res.data.response;
                    console.log("itemss" + datas);
                    const user = datas.map((item, index) => (

                        <tr style={{ textAlign: "center" }} id={"chk" + item.ddchrleave_id} >
                            <td>{index + 1}</td>
                            {/* <td>{item.ddchrleave_staffname}</td> */}
                            <td>{item.ddchrleave_appliedfordate === "0000-00-00 00:00:00"
                                ? ""
                                : Moment(item.ddchrleave_appliedfordate).format("DD-MM-YYYY")}

                                {" - "}
                                {item.ddchrleave_appliedtodate === "0000-00-00 00:00:00"
                                    ? ""
                                    : Moment(item.ddchrleave_appliedtodate).format("DD-MM-YYYY")}

                            </td>
                            {/* <td>{item.ddchrleave_appliedfordate}</td> */}
                            <td>{item.ddchrleave_description}</td>

                            <td >        <div>
                                {(() => {
                                    if (item.ddchrleave_status == 1) {
                                        return (
                                            <div>
                                                <span class="badge bg-info" >
                                                    Open
                                                </span>
                                            </div>
                                        );
                                    }
                                    else if (item.ddchrleave_status == 2) {
                                        return (
                                            <div>
                                                <span class="badge bg-warning" >
                                                    In process
                                                </span>
                                            </div>
                                        );
                                    }


                                    else {
                                        return (
                                            <div>
                                                <span class="badge bg-success" >
                                                    Approved
                                                </span>
                                            </div>
                                        );
                                    }
                                })()}
                            </div></td>

                            <td>
                                {item.ddchrleave_status != 3 ? (<center><i class="text-primary fa fa-edit" onClick={() => Editleaves(item.ddchrleave_id)}></i></center>) : ""}

                            </td>

                            {/* <td>

                                <i class="text-danger fa fa-trash"></i>



                            </td> */}
                        </tr>
                    ));

                    setData(user);
                })
                .catch(error => {
                    alert(error);
                })
        }
        GetAllLeave();
    }, []);

    const handleShowDialog = () => {

        setShow(true);

    };


    const handleShowDialogs = () => {

        setShows(true);

    };




    useEffect(() => {
        const getstaffs = () => {
            axios.get(baseurladdress + `findallstaff`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
                .then(res => {
                    const data = res.data.response;
                    const user = data.map((item, index) => {
                        return (
                            <option value={item.staff_id}> {item.staff_name} </option>
                        )
                    }
                    );
                    setstaff(user);
                }).catch(error => {
                    alert(error);
                })
        }
        getstaffs()

    }, [])



    const closeimagemodal = (event) => {
        event.preventDefault();
        setShow(false);
    }

    const closeimagemodals = (event) => {
        event.preventDefault();
        setShows(false);
    }

    const change = (event) => {
        var index = event.nativeEvent.target.selectedIndex;
        var coun = event.nativeEvent.target[index].text;
        setstaffname(coun)
    }


    //Apply leave 

    const handleSubmit = (event) => {

        event.preventDefault();
        const data = {
            ddchrleave_staffid: id,
            ddchrleave_staffname: username,
            ddchrleave_appliedfordate: leavedate,
            ddchrleave_description: reason,
            ddchrleave_appliedtodate: leavedateto


        };


        if (reason == "") {
            alert("Enter reason for leave");
        }
        // else if (leavedate == "") {
        //     alert("Enter reason for leave");
        // }
        else if (leavedateto == "") {
            alert("Enter leave date to");
        }


        else

            fetch(
                baseurladdress + `addleave`,
                {
                    method: "POST",

                    body: JSON.stringify(data),
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accesstoken}`,
                    },
                }
            )
                .then((res) => res.json())
                .then((result) => {
                    if (result["status"] === "success") {

                        //alert("Staff added successfully");
                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 400,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener('mouseenter', Swal.stopTimer)
                                toast.addEventListener('mouseleave', Swal.resumeTimer)
                            }
                        })
                        Toast.fire({
                            icon: 'success',
                            title: 'Leave added successfully'
                        })
                        //window.location.href = "/stafflist";
                        window.location.reload();
                        navigate("/listleave");
                    }
                });
    };



    //Edit leave

    const Editleaves = (ddchrleave_id) => {
        setShows(true);
        axios
            .get(baseurladdress + `editleave/` + ddchrleave_id, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                const data = res.data.response;
                // setddchrleave_id(data[0].ddchrleave_id);
                setstaffname(data[0].ddchrleave_staffname);
                setddchrleave_id(data[0].ddchrleave_id)

                // setddchrleave_id(data[0].ddchrleave_staffid)
                // const user = data.map((item, index) => {
                //     var selectedd = (item.staff_id === ddchrleave_id
                //     ) ? ' selected' : '';
                //     return (
                //         <option value={item.staff_id} selected={selectedd}> {item.staff_name} </option>
                //     )
                // }
                // );
                // setstaffedit(user);

                setleavedate(
                    Moment(new Date(data[0].ddchrleave_appliedfordate)).format("YYYY-MM-DD")
                );
                setleavedateto(
                    Moment(new Date(data[0].ddchrleave_appliedtodate)).format("YYYY-MM-DD")
                );


                setreason(data[0].ddchrleave_description);


            });



    };


    const handleSubmits = (event) => {
        console.log(status);
        event.preventDefault();
        const data = {

            ddchrleave_description: reason,
            ddchrleave_appliedfordate: leavedate,
            ddchrleave_appliedtodate: leavedateto
        };


        fetch(baseurladdress + `updateleavebystaff/` + ddchrleave_id,
            {
                method: "POST",

                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesstoken}`,
                },
            }
        )
            .then((res) => res.json())
            .then((result) => {
                console.log(result);
                if (result["status"] === "updated") {

                    //alert("Staff added successfully");
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 400,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })
                    Toast.fire({
                        icon: 'success',
                        title: 'Updated successfully'
                    });

                    window.location.reload();

                    navigate("/listleave");
                }
            });
    };





    return (

        <>
            <Sidennav />
            <Topnavbar />
            <div className="content-wrap">
                <div className="main">
                    <div className="container-fluid">

                        <div className="col-lg-12">

                            <div className="card">

                                <div class="card-header" style={{ "color": "black" }}>
                                    <h6 class="card-title"> Leave Details
                                    </h6>

                                </div>


                                <div className="card-body">

                                    <div class="row mb-2">

                                        <div class="col-sm-12 float-lg-right text-right">
                                            <button
                                                type="button"
                                                class="d-grid gap-2 d-md-flex justify-content-md-end"
                                                className="btn btn-primary"
                                                onClick={handleShowDialog}
                                            >
                                                Apply Leave
                                            </button>
                                        </div>
                                    </div>

                                    <div className="card">

                                        <div className="card-body">


                                            <div className="table-responsive">
                                                <table className="table table-bordered table-responsive-sm">
                                                    <thead>
                                                        <tr>
                                                            <th >Sl.no</th>
                                                            {/* <th style={{ "textAlign": "center" }}>Staff Name</th> */}
                                                            <th >Leave Date</th>
                                                            <th >Reason for Leave</th>
                                                            <th >Status</th>
                                                            <th >Edit</th>


                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {data}
                                                    </tbody>
                                                </table>
                                            </div></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div></div></div>
            <Modal show={showModal} >

                <Modal.Header>
                    <h5 >Leave Application</h5>
                </Modal.Header>
                <Modal.Body>
                    <form encType="multipart/form-data">
                        <div className="form-group row">


                            <div class="card-body">
                                <div class="basic-form" >

                                    <div class="form-row">

                                        {/* <div class="col-sm-12">
                                            <h6>Staff name </h6>

                                            <select
                                                className="form-control select"
                                                name="staffname"
                                                required
                                                onChange={(e) => { setstaffid(e.target.value); change(e) }}
                                            >

                                                <option value="" disabled selected>
                                                    Select
                                                </option>
                                                {staff}
                                            </select>
                                        </div> */}



                                        <input
                                            type="hidden"
                                            name="id"
                                            value={id}
                                            id="id"
                                        />




                                        <input
                                            type="hidden"
                                            name="username"
                                            value={username}
                                            id="username"
                                        />



                                        <div class="col-sm-12 ">
                                            <h6>Reason for Leave</h6>
                                            <textarea class="form-control text textaddstaff" onChange={(e) => setreason(e.target.value)} required />
                                        </div>
                                        <div class="col-sm-6 mt-2 mt-sm-0">
                                            <h6>  Date From </h6>
                                            <input
                                                type="date"
                                                className="form-control"
                                                onChange={(e) => setleavedate(e.target.value)}
                                                defaultValue={defaultValue}
                                                min={new Date().toISOString().split("T")[0]}
                                                required
                                            />

                                        </div>


                                        <div class="col-sm-6 mt-2 mt-sm-0">
                                            <h6>  Date To </h6>
                                            <input
                                                type="date"
                                                className="form-control"
                                                onChange={(e) => setleavedateto(e.target.value)}
                                                required

                                            />

                                        </div>



                                        {/* <div class="col-sm-6 mt-2 mt-sm-0">
                                            <h6>Status </h6>
                                            <select
                                                className="form-control select"
                                                name="employee"



                                            >

                                                <option value="" disabled selected>
                                                    select
                                                </option>
                                                <option value="1">
                                                    Open
                                                </option>
                                                <option value="2">
                                                    In Process
                                                </option>
                                                <option value="3">
                                                    Approved
                                                </option>
                                            </select>

                                        </div> */}

                                    </div>
                                </div>

                            </div>

                        </div>
                        <Modal.Footer>
                            <button
                                className="button1 btn btn-success"
                                type="button"
                                onClick={handleSubmit}
                            >
                                Add
                            </button>
                            <Button
                                className="button1"
                                variant="danger"
                                onClick={closeimagemodal}
                            >
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </form>

                </Modal.Body>

            </Modal>





            {/* Update */}



            <Modal show={showModals} >

                <Modal.Header>
                    <h5 > Edit Leave Application</h5>
                </Modal.Header>
                <Modal.Body>
                    <form encType="multipart/form-data">
                        <div className="form-group row">


                            <div class="card-body">
                                <div class="basic-form" >

                                    <div class="form-row">


                                        <div class="col-sm-12 ">
                                            <h6>Reason for Leave</h6>
                                            <textarea class="form-control text textaddstaff" value={reason} onChange={(e) => setreason(e.target.value)} />
                                        </div>
                                        <div class="col-sm-6 mt-2 mt-sm-0">
                                            <h6>  Date  From</h6>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={leavedate}
                                                // value={leavedate}
                                                onChange={(e) => setleavedate(e.target.value)}
                                            />

                                        </div>

                                        <div class="col-sm-6 mt-2 mt-sm-0">
                                            <h6>  Date To</h6>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={leavedateto}
                                                onChange={(e) => setleavedateto(e.target.value)}
                                            />

                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>
                        <Modal.Footer>
                            <button
                                className="button1 btn btn-success"
                                type="button"
                                onClick={handleSubmits}
                            >
                                Update
                            </button>
                            <Button
                                className="button1"
                                variant="danger"
                                onClick={closeimagemodals}
                            >
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </form>

                </Modal.Body>

            </Modal>




        </>



    )

}

export default MyLeavelist;